import './style.css';

function install_user_toolbar() {
    let div, sb, app, content_type, category_id, show_popup;

    app = document.querySelector('#app');
    content_type = app.getAttribute('data-content-type');
    category_id = app.getAttribute('data-category-id');
    show_popup = app.getAttribute('data-show-popup');

    sb = new Array();
    
    sb.push('<span data-cmd="home" style="--scale:1.175" data-tippy="Home" data-tippy-en="Home">' + Graphite.icons['home'] + '</span>');

    if (Graphite.has_permission('#theme#')) {
        sb.push('<span data-cmd="light-theme" class="hide-on-light" style="--scale:1.65" data-tippy="Light Theme" data-tippy-en="Light Theme">' + Graphite.icons['sun'] + '</span>');
        sb.push('<span data-cmd="dark-theme" class="hide-on-dark" data-tippy="Dark Theme" data-tippy-en="Dark Theme">' + Graphite.icons['moon'] + '</span>');
    }
    
    if (Graphite.has_permission('#shopping-cart#')) {
        sb.push('<span data-cmd="view-cart" data-items="0" style="--scale:1.25" data-tippy="ตระกร้าสินค้า" data-tippy="Shopping Cart">' + Graphite.icons['cart'] + '</span>');    

        if (!Graphite.config.require_email) {
            sb.push('<span data-cmd="my-orders" style="--scale:1.5" data-tippy="รายการสั่งซื้อของฉัน" data-tippy-en="My Orders">' + Graphite.icons['layers'] + '</span>');
        }
    }

    if (Graphite.has_permission('#articles#')) {
        sb.push('<span data-cmd="articles" style="--scale:1.1" data-tippy="บทความ" data-tippy-en="Articles">' + Graphite.icons['article'] + '</span>');    
    }

    if (Graphite.has_permission('#news#')) {
        sb.push('<span data-cmd="news" style="--scale:1.05;top:1px" data-tippy="ข่าว และ กิจกรรม" data-tippy-en="News">' + Graphite.icons['news'] + '</span>');    
    }

    if (navigator.share) {
        sb.push('<span data-cmd="share" data-tippy="Share" data-tippy-en="Share" style="--scale:0.9">' + Graphite.icons['share'] + '</span>');
    }

    div = document.createElement('div');
    div.setAttribute('data-role', 'user-toolbar');
    div.classList.add('notranslate');
    div.html(sb.join(''))

    div.on('click', evt => {
        let el = evt.target;

        if (el.matches('[data-cmd]')) {
            let cmd = el.getAttribute('data-cmd');

            switch (cmd) {
                case 'home':
                    document.location = Graphite.config.www_root + 'home'
                    break;

                case 'light-theme':
                    Graphite.set_theme('light');
                    break;

                case 'dark-theme':
                    Graphite.set_theme('dark');
                    break;

                case 'view-cart': {
                        if (Graphite.has_permission('#shopping-cart#')) {
                            Graphite.shopping_cart.get_summary().then(node => {
                                if (node.total_items == 0) {
                                    let msg = 'ขณะนี้ยังไม่มี "สินค้า" ในตระกร้า กรุณา "สั่งซื้อสินค้า" ก่อนนะ' + Graphite.get_ending() + '!';

                                    Graphite.show_message(msg); 
                                } else {
                                    Graphite.shopping_cart.view_cart().then(res => {
                                        if (res.cmd == 'ok') {
                                            let node = res.value;
                                            
                                            Graphite.shopping_cart.save_order(node).then(node => {
                                                Graphite.shopping_cart.empty();
                                                Graphite.shopping_cart.view_order(node.id);
                                            })                                            
                                        }
                                    })
                                } 
                            })
                        }
                    }

                    break;   

                case 'my-orders':
                    Graphite.shopping_cart.my_orders();
                    break;

                case 'articles':
                    window.open('articles', '_self');
                    break;

                case 'news':
                    window.open('news', '_self');
                    break;

                case 'share': {
                        let meta = document.head.querySelector('meta[name="application-name"][content="8columns"]');

                        if (meta) {
                            let id = meta.getAttribute('data-id');

                            if (id) {
                                Graphite.get_meta_data(id).then(node => {
                                    let data = {
                                        title: node.title,
                                        text: node.description,
                                        url: Graphite.default(node.type, 'page') + '/' + node.id
                                    }

                                    if (node.slug) {
                                        data.url = Graphite.config.www_root + node.slug;
                                    } else {
                                        data.url = Graphite.config.www_root + Graphite.default(node.type, 'page') + '/' + node.id
                                    }

                                    navigator.share(data);
                                })
                            }
                        }
                    }

                    break;
            }
        }
    })

    if (!Graphite.is_mobile_browser()) {
        let default_language = Graphite.config.default_language;

        if (Graphite.tippy) {
            div.querySelectorAll('[data-tippy]').forEach(el => {
                if (default_language != 'th') {
                    Graphite.tippy.mount(el, el.getAttribute('data-tippy-en'));
                } else {
                    Graphite.tippy.mount(el, el.getAttribute('data-tippy'));
                }
            })
        }
    }

    document.body.append(div);
}

export { install_user_toolbar }